import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { defaultContext, getInitialStyle } from './podcastInformationEntry.style';

export class PodcastInformationEntry extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Title: {},
        Details: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _detach() {
    this.tag('Title').removeAllListeners('txLoaded');
    this.tag('Details').removeAllListeners('txLoaded');
  }

  set data(content) {
    if (!content) {
      return;
    }

    this.patch({
      Title: {
        visible: Boolean(content.title),
        text: {
          text: content.title,
          wordWrapWidth: content.w,
        },
      },
      Details: {
        visible: Boolean(content.details),
        text: {
          text: content.details,
          wordWrapWidth: content.w,
        },
      },
    });
  }
}
